import { render, staticRenderFns } from "./AgregarHorario.vue?vue&type=template&id=aa53a1f4&"
import script from "./AgregarHorario.vue?vue&type=script&lang=js&"
export * from "./AgregarHorario.vue?vue&type=script&lang=js&"
import style0 from "./AgregarHorario.vue?vue&type=style&index=0&id=aa53a1f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports